const TM_CID = 't';
const TM_CAMPAIGN_ID = 13;
const TM_DEFAULT_CAMPAIGN_ID = 12;

export const parseNumericCampaignId = (cid) => {
  if (cid == null || cid === '') {
    return undefined;
  }

  const value = String(cid).trim();

  if (!/^[1-9]\d*$/.test(value)) {
    return undefined;
  }

  return Number(value);
};

export const resolveTmCampaignIdFromCid = (cid) => {
  if (!cid) {
    return undefined;
  }

  const numericCampaignId = parseNumericCampaignId(cid);

  if (numericCampaignId) {
    return numericCampaignId;
  }

  return cid === TM_CID ? TM_CAMPAIGN_ID : TM_DEFAULT_CAMPAIGN_ID;
};

export const pickCidFromSearchParams = (params = {}, fallback = {}) => {
  return (
    params.Cid ||
    params.cid ||
    fallback.Cid ||
    fallback.cid ||
    undefined
  );
};
